import { Component, OnInit, Input } from '@angular/core';
import { AuthorizatorService } from '../../services/authorizator.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { DataSource } from '@angular/cdk/table';
import { UserObj } from '../../classes/user-obj';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { UpsertUserComponent, DialogData } from './upsert-user/upsert-user.component';
import { DeleteUserWarningComponent } from './delete-user-warning/delete-user-warning.component';
import { PermissionManagerComponent, PermissionData } from '../permission-manager/permission-manager.component';
import { ProgressbarService } from '../../services/progressbar.service';

export class UsersDatabase {
  dataChange: BehaviorSubject<UserObj[]> = new BehaviorSubject<UserObj[]>([]);
  get data(): UserObj[] { return this.dataChange.value; }

  constructor() { }
}

export class UsersDataSource extends DataSource<any> {
  constructor(private usersDatabase: UsersDatabase) {
    super();
  }

  connect(): Observable<UserObj[]> {
    return this.usersDatabase.dataChange;
  }

  disconnect() {}
}


@Component({
  selector: 'lib-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
  @Input() rootFirebasePath: string;
  public displayedColumns = ['remove', 'user', 'permissions'];
  private usersDatabase = new UsersDatabase();
  public usersDataSource: UsersDataSource | null;
  public users: UserObj[] = [];
  constructor(
    private authorizatorservice: AuthorizatorService, public dialog: MatDialog,
    private snackbar: MatSnackBar,
    private progressbarservice: ProgressbarService
  ) { }

  ngOnInit() {
    this.progressbarservice.showUsersWaitBar(true);
    this.authorizatorservice.getUsers(this.rootFirebasePath).then(users => {
      this.progressbarservice.showUsersWaitBar(false);
      if (users) {
        this.users = users.sort((prev, curr) => {
          if (prev.data.name > curr.data.name) {
            return 1;
          }
          if (prev.data.name < curr.data.name) {
            return -1;
          }
          return 0;
        });
        this.usersDataSource = new UsersDataSource(this.usersDatabase);
        this.usersDatabase.dataChange.next(users);
      }
    });
  }

  addUser() {
    const dialogRef = this.dialog.open(UpsertUserComponent, {
      width: '300px',
      data: { type: 'add', user: null, rootFirebasePath: this.rootFirebasePath } as DialogData
    });

    dialogRef.afterClosed().subscribe(userAdded => {
      if (userAdded) {
        this.users.push(userAdded);
        this.users = this.users.sort((prev, curr) => {
          if (prev.data.name > curr.data.name) {
            return 1;
          }
          if (prev.data.name < curr.data.name) {
            return -1;
          }
          return 0;
        });
        this.usersDatabase.dataChange.next(this.users);
        const config: MatSnackBarConfig = new MatSnackBarConfig();
        config.duration = 3000;
        config.panelClass = ['success-bar'];
        this.snackbar.open('User added successfully', null, config);
      }
    });
  }

  removeUser(user: UserObj) {
    const dialogRef = this.dialog.open(DeleteUserWarningComponent, {
      width: '300px',
      data: user
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response) {
        this.progressbarservice.showUsersWaitBar(true);
        this.authorizatorservice.removeUser(this.rootFirebasePath, user.id).then(() => {
          this.progressbarservice.showUsersWaitBar(false);
          this.users.splice(
            this.users.findIndex(userArr => userArr.id === user.id), 1
          );
          this.usersDatabase.dataChange.next(this.users);
          const config: MatSnackBarConfig = new MatSnackBarConfig();
          config.duration = 3000;
          config.panelClass = ['success-bar'];
          this.snackbar.open('User removed successfully', null, config);
        }).catch(error => {
          const config: MatSnackBarConfig = new MatSnackBarConfig();
          config.duration = 3000;
          config.panelClass = ['error-bar'];
          this.snackbar.open(error.message, null, config);
        });
      }
    });
  }

  setPermissions(userInput: UserObj) {
    const dialogRef = this.dialog.open(PermissionManagerComponent, {
      width: '95%',
      maxWidth: '600px',
      data: { rootFirebasePath: this.rootFirebasePath, user: userInput } as PermissionData
    });
  }
}
